import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  description: string | undefined;
}

const ProviderDescription = ({ description }: Props) => (
  <Box className="provider-description">
    <Typography
      sx={{
        maxWidth: "100%",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "pre-wrap",
      }}
    >
      {description || "—"}
    </Typography>
  </Box>
);

export default ProviderDescription;
